import React from 'react';

export default function Layout({ children, flushMobile = false }) {
  const gutterClass = flushMobile ? 'px-0 md:px-8' : 'px-4 md:px-8';

  return (
    <div className={`max-w-7xl w-full mx-auto ${gutterClass}`}>
      {children}
    </div>
  );
}
